import React, {useEffect, useRef, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useDispatch, useSelector } from 'react-redux'
import { useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../../hooks/common'
import { FormattedMessage, useIntl } from 'react-intl'
import { updateCustomerSave } from '../../../../../../api'
// import Toast from '../../../../../components/toast'
import { BigButton } from '../../../../../components/button'
import MeChildHeader from '../../../components/me-child-header'
import MeLoading from '../../../components/loading'
import { action_fetch_customer } from '../../../../../../store/actions/pages/customer'

const SetBio = props => {
    useStyles(classes)
    const [loading, setLoading] = useState(false)
    const [bioValue, setBioValue] = useState('')
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()
    const Intl = useIntl()
    const dispatch = useDispatch()

    const pageCustomer = useSelector(state => state.pageCustomer)
    const {customer} = pageCustomer || {}
    const { bio } = customer || {}

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await SetBio.fetchData(store, params, query)
		}
    }, [customer?.id])

    useEffect(() => {
        if(customer?.id){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[customer])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        if(bio){
            setBioValue(bio)
        }
    }, [bio])

    const saveHandle = async() => {
        setLoading(true)
        let params = {
            customer:{
                bio: bioValue,
            },
            name: 'bio'
        }
        const response = await updateCustomerSave(params)
        setLoading(false)
        if(response?.code == 200){
            await dispatch(action_fetch_customer())
            history.goBack()
        } else {
            alert(response?.result || response)
        }
    }

    return (
        <div className={classes.SetBioPage}>
            <MeChildHeader name={Intl.formatMessage({id: 'bio'})}/>

            <div className={classes.SetForm}>
                <div>
                    <textarea
                        maxLength={100}
                        name="bio"
                        placeholder='Bio'
                        value={bioValue}
                        onChange={(e) => {
                            setBioValue(e?.target?.value)
                        }}
                    />
                    <span className={classes.NumLimit}>
                        {(bioValue?.length ? (100 - bioValue?.length): 0) +' /100'}
                    </span>
                </div>
            </div>

            <div className={classes.SignOutButton}>
                <BigButton onClick={saveHandle}><FormattedMessage id="save" defaultMessage="Save"/></BigButton>
            </div>

            <MeLoading loading={loading}/>
        </div>
    )
}


SetBio.fetchData = async (store, params, search, headers) => {
}

export default SetBio